

import React from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { deletePagesD } from "../../../Services/PageDesign";
// import { deletePagesD } from "../../../Services/PageDesign";

const PageDelete = ({ open, onClose, page_format_id, onSuccess }) => {
  const { mutate: deletePage, isLoading } = useMutation(deletePagesD, {
    onSuccess: (response) => {
      if (
        response?.data?.response_code === 200 ||
        response?.data?.success === true
      ) {
        toast.success(
          response?.data?.message || "Page Design deleted successfully",
        );

        onClose();

        if (onSuccess) {
          onSuccess();
        }
      } else {
        toast.warning(
          response?.data?.message || "Failed to delete Page Design",
        );
      }
    },

    onError: (error) => {
      console.error("DELETE PAGE DESIGN ERROR:", error);

      toast.error(
        error?.response?.data?.message ||
          "Failed to delete Page Design",
      );
    },
  });

  if (!open) {
    return null;
  }

  const handleDelete = () => {
    if (!page_format_id) {
      toast.error("Page Design ID not found");
      return;
    }

    // Service ko change nahi karna hai.
    // ID direct component se API ko bhej rahe hain.
    deletePage({
      page_format_id: Number(page_format_id),
    });
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">
              Delete Page Design
            </h2>

            <p className="mt-1 text-sm text-gray-500">
              Are you sure you want to delete this page design?
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="text-xl text-gray-400 transition hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        {/* ID */}
        <div className="mt-5 rounded-lg bg-gray-50 p-4">
          <p className="text-sm text-gray-500">
            Page Format ID
          </p>

          <p className="mt-1 text-lg font-semibold text-gray-800">
            #{page_format_id}
          </p>
        </div>

        {/* Warning */}
        <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-4">
          <p className="text-sm text-red-600">
            This action cannot be undone. The selected page
            design will be permanently deleted.
          </p>
        </div>

        {/* Buttons */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleDelete}
            disabled={isLoading}
            className={`rounded-lg px-5 py-2.5 text-sm font-semibold text-white transition ${
              isLoading
                ? "cursor-not-allowed bg-gray-400"
                : "bg-red-600 hover:bg-red-700"
            }`}
          >
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageDelete;